const GrayBackground = () => {
  return (
    <div
      className={`
        absolute left-0 top-0 -z-50 size-full bg-gray-1
      `}
    />
  );
};

interface LayoutProps {
  children: React.ReactNode;
}
const MainLayout = (props: LayoutProps) => {
  const { children } = props;

  return (
    <>
      <GrayBackground />
      {children}
    </>
  );
};

export { GrayBackground, MainLayout };
